module.exports = __webpack_public_path__ + "img/report-mobile.b70c67cd.png";